import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Button from '../../../../UI/button';
import GreenRedButtonBlock from '../../../../UI/green-red-button-block';
import BotTableRow from '../../../../UI/bot-table-row';
import AreUSureModal from '../../../../UI/are-u-sure-modal';

import style from '../provider-bot-page/provider-bot-page.module.scss';

const StrategyBotView = ({
    botsData,
    areUSureModal,
    createNewBot,
    stopAllBots,
    yesBtnAreUSureModal,
    switchAreUSureModal,
    switchStatusStrategy,
    deleteStrategyBot,
    editStrategyBot,
    cannotChahgeBot,
    startAllBots,
    disabledStartAllBtn,
    goToPreview,
}) => {
    const { t } = useTranslation();

    return (
        <div className={style.botsWrapper}>
            <div className={style.botsWrapper__bot}>
                <p className={style.botsWrapper__bot_title}>
                    {t('aside.strategy')} / {t('aside.volumeBots')} / {t('aside.bots')}
                </p>
                <div className={style.buttonsWrapper}>
                    <GreenRedButtonBlock
                        greenRedButtonWrapper={style.greenRedButtonWrapper}
                        botsData={botsData}
                        hideIfLessOne
                        clickGreenBtn={createNewBot}
                        clickRedBtn={stopAllBots}
                        greenBtnText={t('generals.createNew')}
                        redBtnText={t('generals.stopAll')}
                    />
                    <Button
                        onClick={startAllBots}
                        className={style.startAllBotsBtn}
                        type="button"
                        disabled={disabledStartAllBtn}
                    >
                        {t('generals.startAll')}
                    </Button>
                </div>
                <BotTableRow
                    botsData={botsData}
                    switchStatusProvider={switchStatusStrategy}
                    deleteBotHandler={deleteStrategyBot}
                    editProviderBot={editStrategyBot}
                    cannotChahgeBot={cannotChahgeBot}
                    cancelOrders
                    isCancelOrders={false}
                    goToPreview={goToPreview}
                />
            </div>
            <AreUSureModal
                visibleModal={areUSureModal}
                noButton={switchAreUSureModal}
                yesButton={yesBtnAreUSureModal}
            />
        </div>
    );
};

StrategyBotView.defaultProps = {
    botsData: [],
    areUSureModal: false,
    disabledStartAllBtn: false,
    startAllBots: () => {},
    stopAllBots: () => {},
    createNewBot: () => {},
    switchStatusStrategy: () => {},
    deleteStrategyBot: () => {},
    editStrategyBot: () => {},
    yesBtnAreUSureModal: () => {},
    switchAreUSureModal: () => {},
    cannotChahgeBot: () => {},
    goToPreview: () => {},
};

StrategyBotView.propTypes = {
    botsData: PropTypes.arrayOf(PropTypes.object),
    areUSureModal: PropTypes.bool,
    disabledStartAllBtn: PropTypes.bool,
    startAllBots: PropTypes.func,
    stopAllBots: PropTypes.func,
    createNewBot: PropTypes.func,
    switchStatusStrategy: PropTypes.func,
    deleteStrategyBot: PropTypes.func,
    editStrategyBot: PropTypes.func,
    yesBtnAreUSureModal: PropTypes.func,
    switchAreUSureModal: PropTypes.func,
    cannotChahgeBot: PropTypes.func,
    goToPreview: PropTypes.func,
};

export default StrategyBotView;
